import { Col, Container, Image, Row } from "react-bootstrap";

const WhyHireDedicatedDevelopers = () => {
  return (
    <Container className="why-hire-dedicated-developers margin-bottom-70">
        <Row>
            <Col className="d-flex justify-content-center align-items-center">
                <Image src="/images/hire-full-time-developer.png" alt="Hire Developers" />
            </Col>
            <Col>
                <h2 className="section-title">Why Hire <span>Dedicated Developers?</span></h2>
                <p>
                    In today’s fast-evolving digital world, businesses need agile, cost-effective, and scalable solutions for software development. Hiring dedicated developers is the ideal approach to building high-quality solutions while maintaining flexibility and efficiency.
                </p>
                <ul>
                    <li>
                        Reduce overhead costs, such as recruitment, training, and infrastructure expenses, while accessing top-tier talent.
                    </li>
                    <li>
                        Dedicated developers bring specialized knowledge in various technologies, ensuring high-quality code and efficient problem-solving.
                    </li>
                    <li>
                        With a focused development team, projects are completed more efficiently, allowing businesses to launch products faster.
                    </li>
                    <li>
                        Easily scale your team based on project needs, whether you require short-term assistance or long-term development support.
                    </li>
                </ul>
            </Col>
        </Row>
    </Container>
  );
}

export default WhyHireDedicatedDevelopers;